import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { helper } from 'src/environments/helper';
import { PermissionsService } from 'src/app/services/permissions.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { EmailComponent } from './tabele-notificari/email/email.component';
import { SmsComponent } from './tabele-notificari/sms/sms.component';
import { FormControl, FormGroup } from '@angular/forms';
import { countriesList, ICountryOption, OptionRom } from 'src/app/shared/countries-list';
import { MatCalendar } from '@angular/material/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-notificari',
    templateUrl: './notificari.component.html',
    styleUrls: ['./notificari.component.scss']
})
export class NotificariComponent implements OnInit {
    @ViewChild(EmailComponent) appEmail!: EmailComponent;
    @ViewChild(SmsComponent) appSms!: SmsComponent;

    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;

    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.rerenderChildDT(this.selectedToggle);
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.rerenderChildDT(this.selectedToggle);
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    activeFilters = 0;
    searchParamsForm!: FormGroup;

    initialFormValues = {
        numarCerere: null,
        numarCerereIntern: null,
        email: '',
        telefon: '',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            numarCerere: new FormControl(null),
            numarCerereIntern: new FormControl(null),
            email: new FormControl(''),
            telefon: new FormControl(''),
        });
    }

    checkActiveFilters() {
        this.activeFilters = 0;
        const currentFilters = this.searchParamsForm.value;

        for (const [key, value] of Object.entries(this.initialFormValues)) {
            if (key in currentFilters && currentFilters[key] !== value) {
                this.activeFilters++
            }
        }
    }

    optionRom: ICountryOption = OptionRom;
    currentOption = this.optionRom;
    options: ICountryOption[] = countriesList;

    // Values for category filtering
    categoryToggleOptions = [
        { id: 'email', value: 'Email' },
        { id: 'sms', value: 'SMS' },
    ];

    selectedToggle: string = this.categoryToggleOptions[0].id;

    changeCountry(option: ICountryOption) {
        this.currentOption = option;
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.activeFilters = 0;

        this.rerenderChildDT(this.selectedToggle);
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderChildDT(this.selectedToggle);
        this.checkActiveFilters();
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.buildSearchParamsForm();
    }

    onToggleChange(event: MatButtonToggleChange) {
        this.selectedToggle = event.value;
        this.resetForm();
    }

    rerenderChildDT(child: string) {
        switch (child) {
            case 'email':
                this.appEmail.rerenderDT();
                break;
            case 'sms':
                this.appSms.rerenderDT();
                break;
        }
    }

    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "email": "dgaspc-module.notificari.email.list",
            "sms": "dgaspc-module.notificari.sms.list",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedToggle = this.categoryToggleOptions[0]?.id;
    }

    printChild(child: string) {
        switch (child) {
            case 'email':
                this.appEmail.printNotificari();
                break;
            case 'sms':
                this.appSms.printNotificari();
                break;
        }
    }
}
